export default "__VITE_ASSET__Dg8Mo96l__"